/*
 * @Description: 员工管理接口
 * @Author: l_hc
 * @LastEditors: l_hc
 * @Date: 2019-07-01 14:20:18
 * @LastEditTime: 2019-07-24 14:22:24
 */
import { logistice } from '@/utils/request'
import { LOGISTICE_GATEWAY } from '@/utils/settings' // 请求接口

const BASE_API = `${LOGISTICE_GATEWAY}/website/index/systemUser`

// 员工管理接口
export function staffAll(params) {
  return logistice({
    url: BASE_API,
    method: 'post',
    params: {
      params: JSON.stringify(params)
    }
  })
}

// 新增编辑-手机号验证（查重）
export const getPhoneIf = (params) => {
  return logistice({
    url: BASE_API,
    method: 'post',
    params: {
      params: JSON.stringify(Object.assign({
        methodName: 'findByPhone'
      }, params))
    }
  })
}

// 岗位动态配置
export function findPostType(data) {
  return logistice({
    url: `${LOGISTICE_GATEWAY}/website/index/systemUser`,
    method: 'post',
    data: Object.assign({
      methodName: 'findPostType'
    }, data)
  })
}
